import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '@/app/hook';
import { useLazyUrlCheckerQuery } from '@/app/services/chatbot-rtk.services';
import { BannerHelper } from '@/components/common/BannerToast';
import { PSButton } from '@/components/ui/button';
import InfoMessageAlert from '@/features/bot/InfoMessageAlert';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import { selectCurrentDataState } from '../../create.slice';
import ChatbotName from '../ChatbotName';

const SetInformation = () => {
  const { t } = useTranslation();
  const { clearErrors, register, setValue } = useFormContext();
  const currentData = useAppSelector(selectCurrentDataState);

  useEffect(() => {
    clearErrors();
    if (currentData?.additional_instructions) {
      setValue('additional_instructions', currentData?.additional_instructions || '');
    }
  }, [currentData]);

  return (
    <div className="plug-and-play tw-py-4 md:tw-px-4">
      <div className="tw-w-full tw-min-h-[166px] tw-flex-col tw-justify-start tw-items-start tw-gap-6 tw-inline-flex">
        <div className="tw-self-stretch tw-min-h-[60px] tw-flex-col tw-justify-start tw-items-start tw-gap-8 tw-flex">
          <ChatbotName order="3. " />

          <Form.Group className="tw-mb-3">
            <Form.Label>{t('Wizard/AiAdditionalInfo/key4')}</Form.Label>
            <div className="tw-mb-4">
              <BannerHelper message={t('HelpBanner/AdditionalInfo/hint')} />
            </div>
            <Form.Control
              placeholder={t('KnowledgeBasesCreateAssistantBot/ph-01')}
              type="text"
              as={'textarea'}
              maxLength={10000}
              rows={12}
              defaultValue={''}
              {...register('additional_instructions')}
            />
          </Form.Group>
        </div>
      </div>
    </div>
  );
};

export default WrappedErrorBoundary(SetInformation);
